import * as z from "zod";

/** What a fast-forward push added, e.g. 2 commits ending in "Fix retry backoff". */
const PushedCommits = z.object({
  count: z.number(),
  head_message: z.string(),
  additions: z.number(),
  deletions: z.number(),
});

/** Stamped by the backend's PullRequestPushMirror when the agent pushes to a session's PR. */
const PrPushMetadata = z.object({
  managed_pr_id: z.string(),
  repository: z.string(),
  pr_number: z.number(),
  pr_url: z.string().nullable(),
  before: z.string().nullable(),
  after: z.string(),
  pushed_at: z.string(),
  commits: PushedCommits.nullish(),
});
export type PrPushMetadata = z.infer<typeof PrPushMetadata>;

const parsedByRaw = new WeakMap<object, PrPushMetadata | null>();

export function prPushMetadata(message: {
  role: string;
  metadata?: Record<string, unknown> | null;
}): PrPushMetadata | null {
  if (message.role !== "agent") return null;
  const raw = message.metadata?.pr_push;
  if (typeof raw !== "object" || raw === null) return null;
  let parsed = parsedByRaw.get(raw);
  if (parsed === undefined) {
    const result = PrPushMetadata.safeParse(raw);
    parsed = result.success ? result.data : null;
    parsedByRaw.set(raw, parsed);
  }
  return parsed;
}

/** Same `o/r#1` shape as prKey, without needing the nullable pr_url. */
export function prPushKey(push: PrPushMetadata): string {
  return `${push.repository}#${push.pr_number}`;
}

/** Display-only row, not a turn of this session: working-state and turn-anchoring scans skip it. */
export function isPrPushMessage(message: {
  role: string;
  metadata?: Record<string, unknown> | null;
}): boolean {
  return prPushMetadata(message) !== null;
}
